export default "__VITE_ASSET__2$VslpAf__"